// extracted by mini-css-extract-plugin
export default {"reviewItem":"reviewItem-Qhp7k","loadMore":"loadMore-m5aQl","loadMoreText":"loadMoreText-ad4KS","disabled":"disabled-slnBU"};